import styles from "./legend.css"

const template = `
    <style>
        ${styles}
    </style>
    <div class="legend-container">
        <h3 id="legend-name">Легенда</h3>
        <ul class="legend-list" id="legend-list">
        </ul>
    </div>
`
const templateListItem = (name, color) => `
    <li>
        <div class="color" style="background: ${color}"></div><p>${name}</p>
    </li>
` 

/**
 * @class MSMapLegend
 * @extends Basic
 * @classdesc Легенда карты
 * */
export class Legend {
    constructor(root) {
        this.root = root
        this.init()
        this.render()
    }
    
    init(){
        this.element = document.createElement('div');
        this.element.style.position = "absolute";
        this.setPosition()
        this.element.style.zIndex = 1111;
        this.element.innerHTML = template;
        this.list = this.element.querySelector('#legend-list')
        this.elementName = this.element.querySelector('#legend-name')
        this.setVisible(this.root.displaylegend);
    }

    render(){
        this.list.innerHTML = this.root.groups?.reduce((acc, {name, color}) => acc + templateListItem(name, color), "") ?? "";
    }

    changeName(name){
        this.elementName.innerHTML = name
        this.elementName.style.display = name.length ? "block" : "none"
    }

    setVisible(value){
       this.element.style.display = value ? 'block' : 'none'
    }

    setPosition(value){
        this.element.style.top = "";
        this.element.style.right = "";
        this.element.style.bottom = "";
        this.element.style.left = "";
        switch(value){
            case 0:
                this.element.style.top = '70px';
                this.element.style.left = 0;
                break;
            case 1:
                this.element.style.top = 0;
                this.element.style.right = 0;
                break;
            case 2:
                this.element.style.bottom = 0;
                this.element.style.left = 0;
                break;
            case 3:
                this.element.style.bottom = 0;
                this.element.style.right = 0;
                break;
            default:
                this.element.style.top = '70px';
                this.element.style.left = 0;
                break;
        }
    }
}
